/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState, useEffect } from "react";
import { Row, Col, Table } from "react-bootstrap";

import { useAuth, useDispatcher } from "../../../components/AuthProvider"

import ModelSummary from "./ModelSummary";
import AccountSummary from "./AccountSummary";

import MonthDetails from "./MonthDetails";
import { Icon } from "../../../components/Icon";


function Dashboard(props) {
  const results = useAuth();
  const dispatch = useDispatcher();
  const [enabled, setEnabled] = useState(results.currentModel.simEnvironment.paramControls.length > 0);


  function enableParamControls(event) {
    event.preventDefault();

    // Add controls to env if enable, otherwise clear them
    let action = {
      type: 'enableParamControls',
    }
    if (enabled) {
      action.type = 'disableParamControls';
    }

    setEnabled(!enabled);
    dispatch(action);
  }


  function onParamValueChange(id, amt) {
    let action = {
      type: 'updateParamControl',
      id,
      value: amt
    }

    dispatch(action);
  }


  const r = results.simResults;
  const sim_env = results.currentModel.simEnvironment;



  let hd_style = {
    display: "inline-block"
  }

  let div_style = {
    overflow: "scroll"
  }


  return (
    <>
      <Row>
        <Col>
          <h5 style={hd_style}>{results.simResults.simModel.baseDesc}</h5>
        </Col>
        <Col>
          <span>{r.setupTime}</span>::
          <span>{r.genTime}</span>::
          <span>{r.sortTime}</span>::
          <span>{r.calcTime}</span>::
        </Col>
      </Row>

      <Row>
        <Col xs={12} sm={3}>
          <Row>
            <Col>
              <div style={{ display: "inline-block", width: "10em", verticalAlign: "top" }}>
                <ModelSummary results={results} enabled={enabled} onParamValueChange={onParamValueChange} />
              </div>
              <div style={{ display: "inline-block", width: "4em", verticalAlign: "top" }}>
                <Score />
              </div>
              <div style={{ display: "inline-block", width: "5em", verticalAlign: "top" }}>
                <Chart />
              </div>
            </Col>
          </Row>


          <Row>
            <Col>
              <WhatIfPanel enabled={enabled} env={sim_env} enableParamControls={enableParamControls} onParamValueChange={onParamValueChange} />
            </Col>
          </Row>

        </Col>

        
        <Col xs={12} sm={9}>
          <Row>
            <Col>
              <NetWorth results={results} />
            </Col>
          </Row>

          <Row>
            <Col>
              <MonthDetails results={results} />
            </Col>
          </Row>


          <div style={div_style}>
            <Row>
              <Col><AccountSummary results={results} model={results.simResults.simModel} /></Col>
            </Row>
          </div>
        </Col>
      </Row>


    </>
  )
}

export default Dashboard;


/*
Skip current month

Slope of growth

Slope of debt reduction

Check unsecured debt ratios

Any delinquant
  if in retirement, fail
  if in working, check percent

Get Net Worth at start of retirement
  ending with less than 10% - warning or error ?
  check for expense types, should it have some vacation ?


*/



function Score(props) {


  let score = 72;

  let score_style = {
    fontSize: "3em",
    //textAlign: "center"
  }


  return (
    <div style={score_style}>
      <span>{score.toString()}</span>
    </div>
  );
}


function Chart(props) {

  return (
    <svg height="80" width="80" xmlns="http://www.w3.org/2000/svg">
      <circle r="30" cx="40" cy="40" fill="red" />
    </svg>
  );
}


function WhatIfPanel(props) {

  //  onChange={ () => console.log('a') } 
  //  onInput={ () => console.log('b') } 

  let what_if_style = {
    background: "#eeeeee",
    margin: "5px"
  }


  return (
    <div style={what_if_style}>
      <div>
        <span>What If</span><Icon.ToolSwitch enabled={props.enabled} onClick={props.enableParamControls} />
      </div>


      <div>
        {props.env.quickControls.map((c, i) => <ActiveAmountControl key={i} control={c} />)}
      </div>
    </div>

  )
}


function ActiveAmountControl(props) {
  const dispatch = useDispatcher();
  const [active, setActive] = useState(props.control.active);
  const [percent, setPercent] = useState(props.control.value);
  const [pctLabel, setPctLabel] = useState(props.control.value);


  function handleActive(event) {
    event.preventDefault();

    setActive(!active);
  }

  function handleValue(event) {
    event.preventDefault();

    setPercent(event.target.valueAsNumber);
  }

  function handleUpdate(event) {
    event.preventDefault();

    setPctLabel(event.target.valueAsNumber);
  }


  useEffect(() => {
    let action = {
      type: 'updateQuickControl',
      id: props.control.id,
      active: active,
      value: percent
    }

    dispatch(action);
  }, [active, percent]);


  let control_style = {
    margin: "5px"
  }

  let check_style = {
    padding: "7px",
    margin: "5px"
  }

  let range_label_style = {
    fontSize: "0.6em"
  }

  let list_style = {
    display: "flex", // This enabled the tick labels, it was default to none
    justifyContent: "space-between",
    width: "129px",

    fontSize: ".6em"
  }

  /*
    //style={{writingMode: "vertical-lr"}}
    return (
      <div style={control_style}>
        <div>
          <span>{props.control.item.baseDesc}</span>
        </div>
  
        <div>
        <input style={check_style} type="checkbox" checked={active} onChange={handleActive} />
        <input type="range" defaultValue={percent} list="steplist" min="0" max="300" step="5"
            onPointerUp={handleValue}
          />
  <datalist style={list_style} id="steplist">
      <option value="0" label="0">0</option>
      <option value="100" >100</option>
      <option value="200" label="200">200</option>
      <option value="300" label="300">300</option>
  </datalist>
  
        </div>
      </div>
    );
  */

  return (
    <div style={control_style}>
      <div>
        <input style={check_style} type="checkbox" checked={active} onChange={handleActive} />
        <span>{props.control.item.baseDesc}</span>
      </div>

      <div>
        <span style={range_label_style}>0%</span>
        <input type="range" defaultValue={percent} list="steplist" min="0" max="300" step="5"
          onPointerUp={handleValue} onChange={handleUpdate}
        />
        <span style={range_label_style}>0%</span>
        <span>{pctLabel}</span>
      </div>
    </div>
  );

}

//onMouseUp={() => console.log('c')}
//onMouseDown={() => console.log('d')}
//onTouchEnd={() => console.log('e')}



// This is starting out as net worth but might end up having overall score folded in as well

function NetWorth(props) {
  let timeline = props.results.simResults.timeSpan;


  return (
    <div>
    <h3>Net worth</h3>

    <table>
      <thead>
        <tr>
          <th></th>
          <th>Today</th>
          <th>Retirement</th>
          <th>Estate</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Cash</td>
          <td>{timeline.curMonth.monthTotals.liquidAssets.toFixed(2)}</td>
          <td>{timeline.retireMonth.monthTotals.liquidAssets.toFixed(2)}</td>
          <td>{timeline.endMonth.monthTotals.liquidAssets.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Debt</td>
          <td>{timeline.curMonth.monthTotals.liabilities.toFixed(2)}</td>
          <td>{timeline.retireMonth.monthTotals.liabilities.toFixed(2)}</td>
          <td>{timeline.endMonth.monthTotals.liabilities.toFixed(2)}</td>
        </tr>
      </tbody>
    </table>
    {timeline.curMonth.index}
    {timeline.retireMonth.index}
    {timeline.endMonth.index}
    </div>

  );
}